import { DefaultRequest } from 'scripts/api';

class SmartGeocodeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'SmartGeocode';
        const model = App.Models.SmartGeocode;
        const collectionClass = App.Collections.SmartGeocode;

        super(entityName, model, collectionClass);

        const options = Monet.Grid.Utils.paginationOptions;
        if (!App.Forms.SmartGeocode) {
            App.Forms.SmartGeocode = {
                layout: {},
                dataMapper: null,
                pagination: {
                    first: options.FIRST,
                    max: options.MAX_RESULT,
                    blocked: false,
                    canIncrement: true
                },
                columnToOrders: []
            };
        }
    }

    createTemplate = (callback) => {
        const smartGeocode = document.querySelector("#SmartGeocode");
        if(smartGeocode.querySelector("#smartGeocodeListConteiner") === null) {
          smartGeocode.appendChild(Greenmile.Templates.getSmartGeocodeListConteiner());
        }
        callback();
    }

    removeElementsMap = () => {

        var smartGeocodeSelector = '#SmartGeocode';
        var mapCon = document.querySelector(smartGeocodeSelector + " #mapCon");
        var streetView = document.querySelector(smartGeocodeSelector + " .streetView");
        var streetViewCloseBtn = document.querySelector(smartGeocodeSelector + " .streetViewCloseBtn");
        var parentNode;

        if (mapCon) {
            parentNode = mapCon.parentNode;

            if (parentNode) {
                parentNode.removeChild(mapCon);
            }
        }

        if (streetView) {
            parentNode = streetView.parentNode;
            if (parentNode) {
                parentNode.removeChild(streetView);
            }
        }

        if (streetViewCloseBtn) {
            parentNode = streetViewCloseBtn.parentNode;

            if (streetViewCloseBtn) {
                parentNode.removeChild(streetViewCloseBtn);
            }
        }
    }

    showListSmartGeocodes = () => {
        this.removeElementsMap();
        this.generateListSmartGeocodes();
    }

    list = () => {
        this.showListSmartGeocodes();
    }

    generateListSmartGeocodes = () => {
        var callback = function () {
            var view = App.Views.SmartGeocode;
            var gridActions = document.getElementById('SmartGeocode').querySelector('.form-vertical.gridActions');
            var hasExist = gridActions.querySelector('#filterSmartGeocode');

            if (!hasExist) {
                var helpTo = 'SmartGeocode';
                var title = Monet.I18n.getResourcesByKey('Greenmile.SmartGeocode.list');
                var helper = new Monet.UI.Help(helpTo, title);

                gridActions.appendChild(helper.render());
                gridActions.insertBefore(view.buildFieldsFilter(), gridActions.firstChild);
            }

            view.showGrid();
        };
        this.createTemplate(callback);
    }

    showDetailSmartGeocode = (locationId) => {
        var detailSmartGeocode = App.Views.SmartGeocode;
        this.removeElementsMap();

        const callback = function () {

            var smartGeocodeListContainer = document.querySelector("#smartGeocodeListConteiner");
            var smartGeocodeDetailHtml = document.querySelector("#smartGeocodeDetail");
            smartGeocodeListContainer.style.display = "none";
            smartGeocodeDetailHtml.appendChild(Greenmile.Templates.getContentSmartGeocodeDetail());
            smartGeocodeDetailHtml.style.display = "block";

            var alertNothingData = function () {
                new Greenmile.Components.AlertModal('SmartGeocode.alert.nothingData')
                    .show();
                window.location.href = '#/SmartGeocode';
            };

            let jsonObject = {
              locationId,
            };

            if (App.Forms.SmartGeocode && App.Forms.SmartGeocode.filterBuilder) {
              const params = App.Forms.SmartGeocode.filterBuilder.getParametersToFilter();
              jsonObject = {
                ...jsonObject,
                ...JSON.parse(params),
              };
              delete jsonObject.firstResult;
              delete jsonObject.maxResults;
            }

            var ajax = new Monet.Ajax();
            ajax.url = 'SmartGeocode/Detail';
            ajax.method = 'POST';
            ajax.data = jsonObject;

            ajax.success = function (data) {
                if (data) {
                    if (!Greenmile.SmartGeocode.data) {
                      Greenmile.SmartGeocode.data = new App.Collections.SmartGeocode([data]);
                    }
                    detailSmartGeocode.showMapAndDetailSmartGeocode(data);
                } else {
                    alertNothingData();
                }
            };

            ajax.error = function (xhr) {
                Monet.Configurations.errorNotification(null, xhr, null, null);
            };

            ajax.send();
        };

        this.createTemplate(callback);
    }

    updatePosition = (locationId, callback) => {
        var position = Greenmile.SmartGeocode.correctPosition;
        var userId = Monet.Session.User.id;

        const request = new DefaultRequest({
            url: "SmartGeocode/" + locationId + "/ByUser/" + userId,
            data: position,
            method: 'put',
            success: function () {
                if (typeof(callback) !== "undefined") {
                    callback();
                }
            }
        });
        request.send();
    }

    setCheckedPosition = (locationId, callback) => {
        const request = new DefaultRequest({
            url: "SmartGeocode/UpdateLastCheck/" + locationId,
            method: 'post',
            success: function () {
                if (callback) {
                    callback();
                }
            }
        });
        request.send();
    }

    getFilter = () => {
        return App.Forms.SmartGeocode.filterBuilder.getParametersToFilter();
    }

    getSmartGeocodes = async (parameters, callback, appendCollection) => {
        var entity = 'SmartGeocode';
        var columns;
        var error;

        if (parameters) {
            try {
                columns = await App.Forms.SmartGeocode.table.getColumns();

                if (!appendCollection) {
                    this.collection.reset();
                }

                this.collection.fetch({
                    data: parameters,
                    method: 'post',
                    add: true,
                    success: function (data) {
                        if (callback) {
                          if (window.GreenmileTabPanel.getActiveTab() !== 'SmartGeocode') {
                            window.GreenmileTabPanel.onSelect(window.Immutable.fromJS({ pathname: '/SmartGeocode' }))
                          }
                          Greenmile.SmartGeocode.data = data;
                          callback(entity, columns, data, true);
                        }
                    }
                });

            } catch (e) {
                error = new Monet.Exception.ReturnError(this, "Error getting smartgeocode.");
                error.console();
            }
        } else {
            error = new Monet.Exception.ReturnError(this, "No parameters to get smartgeocodes");
            error.console();
        }
    }

    updateGrid = (filter, callback, appendCollection) => {
        this.getSmartGeocodes(filter, callback, appendCollection);
    }

    returnToGrid = () => {
        if ($("#SmartGeocode #mapCon")) {
            $("#SmartGeocode #mapCon").remove();
        }
        window.location.href = "#/SmartGeocode";
    }

    getColumnsToGridLayout = async () => {
        var error = null,
            ajax  = null;

        try {
            ajax = new Monet.Ajax();
            ajax.url = 'form/SmartGeocode/index';
            ajax.success = function (data) {
                if (data) {
                    App.Forms.SmartGeocode.layout['index'] = data;
                }
            };

            ajax.error = function (response) {
                Monet.Configurations.errorNotification(null, response);
            };

            await ajax.send();
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, 'Error on get grid layout to SmartGeocode');
            error.console();
        }
    }
}

App.Routers.SmartGeocode = SmartGeocodeRouter;
